import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { notify } from 'components/Common/Toast';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { SendAnnouncementState, NewAnnouncement } from 'types/announcements';

const initialState: SendAnnouncementState = {
    loading: false,
    error: false,
};

export const sendAnnouncement = createAsyncThunkWrapper<any, NewAnnouncement>(
    'announcement/sendAnnouncement',
    async (announcement: NewAnnouncement) => {
        if (!announcement?.companyId) return;
        const res: any = await client.post('/notification/sendNotificationToUsers', announcement);
        if (res?.code === 200) {
            notify('Announcement sent successfully', 'success');
        }
        return res;
    }
);

const sendAnnouncementSlice = createSlice({
    name: 'sendAnnouncement',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(sendAnnouncement.pending, (state) => {
            state.loading = true;
            state.error = false;
        });
        builder.addCase(sendAnnouncement.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(sendAnnouncement.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.error?.message || true;
        });
    },
});

export default sendAnnouncementSlice.reducer;
